import 'babel-polyfill'
import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import { i18n } from './i18n.js'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import store from './store'

//Vue.config.productionTip = false;
const app = createApp(App);
app.use(VueAxios, axios);
app.use(vuetify);
app.use(i18n);
app.use(router);
app.use(store);
app.mount('#app');
